module.exports = __webpack_public_path__ + "img/4@3x.b2b9ffee.png";